<template>
    <div class="row journal-line px-2">
        <div class="col-12 d-flex product-details-border position-relative pe-0">
            <div class="row w-100 pe-lg-0 me-1 py-2">
                <div class="col-md-4 col-12">
                    <div class="mb-1">
                        <label class="form-label" for="product_id">Product</label>
                        <AsyncSelect
                            :api-service="fetchProductList"
                            placeholder="Select Product"
                            v-model="selectedProduct"
                            label="text"
                            :format-label="option => option.text"
                        />
                    </div>
                </div>

                <div class="col-md-2 col-12">
                    <div class="mb-1">
                        <label class="form-label" for="rate">Unit</label>
                        <vField
                            v-model="unit"
                            name="unit"
                            class="form-control text-right"
                            disabled="disabled"
                        />
                    </div>
                </div>

                <div class="col-md-2 col-12">
                    <div class="mb-1">
                        <label class="form-label" for="rate">Rate</label>
                        <vField
                            v-model="data.rate"
                            name="rate"
                            type="number"
                            class="form-control text-right"
                        />
                    </div>
                </div>

                <div class="col-md-2 col-12">
                    <div class="mb-1">
                        <label class="form-label" for="quantity">
                            Quantity
                        </label>
                        <vField
                            v-model="data.quantity"
                            name="quantity"
                            type="number"
                            class="form-control text-right"
                        />
                    </div>
                </div>

                <div class="col-md-2 col-12">
                    <div class="mb-1">
                        <label class="form-label" for="quantity">Amount</label>
                        <vField
                            readonly
                            v-model="amount"
                            name="amount text-right"
                            type="number"
                            class="form-control text-right"
                        />
                    </div>
                </div>

                <div class="col-md-2 col-12">
                    <div class="mb-1">
                        <label class="form-label" for="discount-percent">TD/Commission (%)</label>
                        <vField
                            v-model="data.discount_percent"
                            name="discount-percent"
                            type="number"
                            class="form-control text-right"
                            max="100"
                            min="0"
                        />
                    </div>
                </div>

                <div class="col-md-2 col-12">
                    <div class="mb-1">
                        <label class="form-label" for="discount-amount">TD/Commission Amount</label>
                        <vField
                            v-model="data.discount_amount"
                            name="discount-amount"
                            type="number"
                            class="form-control text-right"
                            min="0"
                        />
                    </div>
                </div>

                <div v-if="isItem" class="col-md-2 col-12">
                    <div class="mb-1">
                        <label class="form-label" for="offer-discount">Offer Discount</label>
                        <vField
                            readonly
                            v-model="data.offer_discount"
                            name="amount text-right"
                            type="number"
                            class="form-control text-right"
                            id="offer-discount"
                        />
                    </div>
                </div>

                <div class="col-md-2 col-12">
                    <div class="mb-1">
                        <label class="form-label" for="quantity">Amount after discount</label>
                        <vField
                            v-model="amountAfterDiscount"
                            name="amount"
                            type="number"
                            class="form-control text-right"
                            readonly=""
                        />
                    </div>
                </div>

                <div class="col-md-2 col-12">
                    <div class="mb-1">
                        <label class="form-label" for="vat">VAT</label>
                        <vField
                            v-model="data.vat"
                            id="vat"
                            as="select"
                            name="vat"
                            class="form-select"
                        >
                            <option
                                v-for="(vat, i) in vatRate"
                                :value="vat.value"
                                :key="i"
                            >
                                {{vat.label}}
                            </option>
                        </vField>
                    </div>
                </div>

                <div class="col-md-2 col-12">
                    <div class="mb-1">
                        <label class="form-label" for="vat_amount">VAT amount</label>
                        <vField
                            v-model="data.vat_amount"
                            name="vat_amount"
                            type="number"
                            class="form-control text-right"
                        />
                    </div>
                </div>

                <div class="col-md-2 col-12">
                    <div class="mb-1">
                        <label class="form-label" for="total_amount">Total Amount</label>
                        <vField
                            v-model="totalAmount"
                            readonly
                            name="total_amount"
                            type="number"
                            class="form-control text-right"
                        />
                    </div>
                </div>

                <div class="col-md-2 col-12">
                    <div class="mb-1">
                        <label class="form-label" for="quantity">Free quantity</label>
                        <vField
                            readonly
                            v-model="data.free_quantity"
                            name="amount text-right"
                            type="number"
                            class="form-control text-right"
                        />
                    </div>
                </div>

                <div class="col-12">
                    <div class="mb-1">
                        <label class="form-label" for="description">Description</label>
                        <vField
                          style="height: 38px"
                          as="textarea"
                          name="description"
                          v-model="data.description"
                          class="form-control"
                        />
                    </div>
                </div>
            </div>

            <div
                @click="$emit('onClose', index)"
                class="
                d-flex
                flex-column
                align-items-center
                justify-content-between
                border-start
                invoice-product-actions
                py-50
                px-25"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     class="feather feather-x cursor-pointer font-medium-3">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </div>

        </div>
    </div>
</template>

<script setup>
import { ref,computed } from "@vue/runtime-core"
import {inject, onMounted, watch} from "vue";
import handlePurchaseAndSales from "@/services/modules/purchase";
import {useRoute} from "vue-router";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";

const showError = inject('showError');

const { fetchProductList, fetchProductStock } = handlePurchaseAndSales();
const route = useRoute();
const productStock = ref(null);
const stockValidationCheck = ref(false);
const selectedProduct = ref(null);

const pr = defineProps({
  title: String,
  data: Object,
  isItem: Boolean,
  index: Number,
  vatRate: Array,
  costCentres: Array,
})

const amount = computed(() => {
    return pr.data.amount = (pr.data.rate * pr.data.quantity).toFixed(2)
})

const amountAfterDiscount = computed(() => {
  let discountAmount = pr.data.discount_amount === '' ? 0 : parseFloat(pr.data.discount_amount)
  discountAmount += pr.data.offer_discount && pr.data.offer_discount !== '' ? parseFloat(pr.data.offer_discount) : 0;

  if(discountAmount === 0) {
    return amount.value;
  }
  return (amount.value - discountAmount).toFixed(2)
})

const vatAmount = computed(() => {
    if(pr.data.vat === 0) {
        return 0
    }

    if(pr.data.vat && pr.isItem) {
        return (pr.data.vat/100 * amountAfterDiscount.value).toFixed(2)
    }
    return (pr.data.vat/100 * amountAfterDiscount.value).toFixed(2);
})

const altQuantity = computed(() => {
  return pr.data.alt_unit_qty
})

watch(vatAmount, (newValue, oldValue) => {
  if(isNaN(oldValue)){
    return pr.data.vat_amount  = pr.data.vat_amount;
  }
  return pr.data.vat_amount  = newValue;
})

watch(altQuantity, (newValue, oldValue) => {
  //to ignore the calculation set quantity during on page load during edit
  if(route.query.grnId && oldValue === null) {
    return;
  }
})

const totalAmount = computed(() => {
    if(pr.data.vat == 0) {
        return pr.data.total_amount = amountAfterDiscount.value
    }
    return pr.data.total_amount = (parseFloat(amountAfterDiscount.value) + parseFloat(pr.data.vat_amount)).toFixed(2)
})

const unit = computed(() => {
    if (selectedProduct.value && selectedProduct.value.description) {
        return selectedProduct.value.description.unit ? selectedProduct.value.description.unit.name : null;
    }

    return '';
})

const productId = computed(() => selectedProduct.value ? selectedProduct.value.id : null)
const accountHeadId = computed(() => pr.data.account_head_id)
const locationId = computed(() => pr.locationId)
const discountPercent = computed(() => {
  return pr.data.discount_percent
})

const setSelectedProduct = () => {
    selectedProduct.value = {
        ...pr.data.product,
        text: pr.data.product.name,
    };
}

watch(accountHeadId, (newValue) => {
    if(newValue){
        const selectedAccountHead = pr.accountHeads.find(acc => acc.id === newValue)
        pr.data.head = {
            'name': selectedAccountHead.name
        }
    }
})

watch(productId, (newValue) => {
    pr.data.product_id = newValue;

    if(newValue === null) {
        clearFields();
        return;
    }

    pr.data.product = {
        'name': selectedProduct.value.text
    }
    pr.data.product_type = selectedProduct.value.product_type;

    //check if the product is a service
    if(selectedProduct.value.product_type === 'services') {
        productStock.value = null;
        stockValidationCheck.value = false;
        return;
    }

    fetchStock(newValue);
})

watch(discountPercent, (value) => {
  let discount = 0;
  value = parseFloat(value);
  if(value && value > 0 && amount.value > 0) {
    discount = amount.value * (value/100);
  }
  pr.data.discount_amount = discount.toFixed(2);
})

watch(amount, (value) => {
  if (value > 0 && discountPercent && discountPercent.value > 0) {
    pr.data.discount_amount = (value * (discountPercent.value/100)).toFixed(2)
    return ;
  }
  pr.data.discount_amount = 0;
})

const fetchStock = (id) => {
  if (productId.value !== null && productId.value != undefined) {
    let query = `?company_id=${route.params.companyId}&skip_stock_check=1`;
    query += ((locationId.value !== null) ? `&location_id=${locationId.value}` : '');
    fetchProductStock(id, query).then(res => {
      productStock.value = null;
      stockValidationCheck.value = true;
      if (res.status === false) {
        pr.data.quantity = 0;
        showError(res.message);
        return;
      }

      productStock.value = res.data.stock;
      if (pr.isEdit){
        productStock.value = productStock.value + pr.data.quantity
      }

      pr.data.rate = pr.data.rate && pr.data.rate > 0 ? pr.data.rate : res.data.sales_rate
      let alertMsg = res.data.name
          ? `${res.data.name} has insufficient stock.`
          : 'Insufficient stock available.';

      if (productStock.value === null && pr.isSaleOrder === false){
        showError(alertMsg)
        pr.data.quantity = 0;
      }

      if (Number(productStock.value) < Number(pr.data.quantity) && pr.isSaleOrder === false){
        showError(alertMsg)
        pr.data.quantity = productStock.value;
      }

    })
  }
}

onMounted(() => {
  fetchProductList.the
    //check if the product is a service
    if (pr.data.product) {
        setSelectedProduct();
    }
})

const clearFields = () => {
    selectedProduct.value = null;
    productStock.value = null;
    pr.data.product_id = null;
    pr.data.quantity = 0;
    pr.data.rate = 0;
}

</script>


<style scoped>
.journal-line{
        border: 1px solid #f0f2f5;
    }
    .journal-line:hover{
        background: #f0f2f5;
    }
</style>

